/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminBlock,
  AdminBlockCreate,
  PatchedAdminBlock
} from '.././model';

import adminV1OrganizationsBlocksCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBlocksUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBlocksPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBlocksDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksCreate = (
    organizationId: number,
    adminBlockCreate: NonReadonly<AdminBlockCreate>,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksCreateMutator<AdminBlockCreate>>,) => {
      return adminV1OrganizationsBlocksCreateMutator<AdminBlockCreate>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminBlockCreate
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksUpdate = (
    organizationId: number,
    id: number,
    adminBlock: NonReadonly<AdminBlock>,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksUpdateMutator<AdminBlock>>,) => {
      return adminV1OrganizationsBlocksUpdateMutator<AdminBlock>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminBlock
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminBlock: NonReadonly<PatchedAdminBlock>,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksPartialUpdateMutator<AdminBlock>>,) => {
      return adminV1OrganizationsBlocksPartialUpdateMutator<AdminBlock>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminBlock
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksDestroyMutator<void>>,) => {
      return adminV1OrganizationsBlocksDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsBlocksCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksCreate>>>
export type AdminV1OrganizationsBlocksUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksUpdate>>>
export type AdminV1OrganizationsBlocksPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksPartialUpdate>>>
export type AdminV1OrganizationsBlocksDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksDestroy>>>
